"use client";

import { ClerkProvider } from "@clerk/nextjs";
import { ui } from '@clerk/ui'

import { DebProvider } from "@/app/deb/services/useDebContext";
import { AnalyticsProvider } from "@/app/components/AnalyticsProvider";
import appConfig from "../app.config";
import { OrientationLockProvider } from "./OrientationLockProvider";
import { ThemeProvider } from "./ThemeProvider";
export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <ClerkProvider ui={ui}>
      <AnalyticsProvider isEnabled={appConfig.analytics.enabled}>
        <OrientationLockProvider orientation="portrait-primary">
          <ThemeProvider>
            <DebProvider>
              {/* It is ok to pass server components as children and they will remain server components */}
              {children}
            </DebProvider>
          </ThemeProvider>
        </OrientationLockProvider>
      </AnalyticsProvider>
    </ClerkProvider>
  );
}

export default AppProviders;
